import React, { useState } from 'react'
import CaseDetailsToggleTile from './CaseDetailsToggleTile'
import CaseDetailsExtraInfo from './CaseDetailsExtraInfo'
import { Plus } from 'lucide-react'

function CaseAdditionalInfo({ caseDetails, uploadDocuments, removeDoc, isCaseOpen }) {
    const [toggleInfo, setToggleInfo] = useState(false)
  return (

    <div>
      <CaseDetailsToggleTile
        toggleInfo={toggleInfo}
        setToggleInfo={setToggleInfo}
        title={"Add Supporting Documents"}
        icon = {<Plus size={18} />}
        variant="accent"
      />    
      {toggleInfo && <CaseDetailsExtraInfo 
                caseDetails={caseDetails}
                uploadDocuments={uploadDocuments}
                removeDoc={removeDoc}
                isCaseOpen={isCaseOpen}
                />
        }
    </div>
  )
}

export default CaseAdditionalInfo
